export default __webpack_public_path__ + "static/media/foodImage.3f82d0ad.svg";